import React, { useEffect } from 'react';
//STYLE
import {
  MainContainer,
  TermsText,
} from './styles';

export default function PrivacyPolicyDoc(props) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <MainContainer>
        <TermsText>
                <>
  <p
    align="center"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
  </p>
  <p
    align="center"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <br />
    <br />
  </p>
  <p
    align="center"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={4} style={{ fontSize: "16pt" }}>
      <b>AVISO DE PRIVACIDADE </b>
    </font>
  </p>
  <p
    align="right"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <br />
    <br />
  </p>
  <p
    align="right"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      <b>Data da última atualização: </b>
    </font>
    <font size={2} style={{ fontSize: "10pt" }}>
      28 de Maio de 2025
    </font>
  </p>
  <p
    align="center"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <br />
    <br />
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.23cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Nós da{" "}
    </font>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>OOPPAH SOLUÇÕES ARTiSTICAS LTDA, </b>
    </font>
    <font size={3} style={{ fontSize: "12pt" }}>
      portadora do CNPJ nº{" "}
    </font>
    23.825.830/0001-53
    <font size={3} style={{ fontSize: "12pt" }}>
      , com sede na Rua Afrânio Melo Franco, , nº 233, quitandinha, Petrópolis, RJ com CEP de 25651-000
      22775-057,
    </font>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b></b>
    </font>
    <font size={3} style={{ fontSize: "12pt" }}>
      compreendemos que o respeito a privacidade do indivíduo e a sua proteção
      de dados são direitos fundamentais.{" "}
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.23cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Por isso, apresentamos nosso Aviso de Privacidade para que você tenha
      conhecimento das regras relacionadas à forma como coletamos, registramos,
      armazenamos, utilizamos, compartilhamos e excluímos seus dados pessoais,
      de acordo com as leis vigentes no Brasil, bem como com as melhores
      práticas de Governança de Dados empregadas na atividade de tratamento de
      dados pessoais.
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.23cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Dessa forma, como condição para prestar nossos serviços ao entrar no site,
      recomendamos a você, usuário, a leitura do presente Aviso, a fim de lhe
      prestar ciência, transparência e informação sobre nossas operações de
      tratamento de dados.
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>
        1. CONCEITOS BÁSICOS: O QUE PRECISO SABER PARA COMPREENDER ESTE AVISO?
      </b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      A fim de te ajudar a compreender este Aviso e cumprir com o dever de
      transparência, apresentamos algumas definições que serão úteis para a sua
      interpretação:
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (i) “Dado Pessoal”: é qualquer dado relativo a um indivíduo identificado,
      tais como nome, sobrenome, RG e CPF, ou identificável, como no caso dos
      dados de geolocalização (GPS), endereço IP, identificação de dispositivo
      etc.
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (ii) “Dado Pessoal Sensível”: é a informação que diz respeito à origem
      racial ou étnica, convicção religiosa, opinião política, filiação a
      sindicato ou a organização de caráter religioso, filosófico ou político,
      dado referente à saúde ou à vida sexual, dado genético ou biométrico,
      quando vinculado a uma pessoa natural.
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (iii) “Tratamento de dados pessoais”: é toda operação realizada com algum
      tipo de manuseio de dados pessoais, seja edição, coleta, arquivamento,
      transferência, armazenamento, utilização, remoção e/ou classificação
      destes dados;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (iv) “Titular” ou “você”: a quem se referem os dados pessoais objetos de
      algum tratamento, e que possui direitos sobre os dados;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (v) “Consentimento”: manifestação livre, informada e inequívoca pela qual
      o titular concorda com o tratamento de seus dados pessoais para uma
      finalidade determinada;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (vi) “Controlador”: é o responsável por tomar as decisões referentes ao
      tratamento de dados pessoais;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (vii) “Operador”: é a pessoa natural ou jurídica que realiza o tratamento
      de dados pessoais em nome do controlador;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (viii) “Encarregado de dados” ou “DPO”: é a pessoa indicada pelo
      controlador para atuar como canal de comunicação entre o controlador, os
      titulares dos dados e a Autoridade Nacional de Proteção de Dados;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (ix) “Aviso de Privacidade” ou “Aviso”: é uma comunicação direcionada aos
      indivíduos externos à organização na condição de titulares de dados
      pessoais informando e descrevendo as operações de tratamento de dados
      realizadas pela organização;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (x) “Privacidade”: é um direito fundamental do indivíduo de manter
      indevassados os dados e as informações que lhe digam respeito. É o
      controle que a ele se assegura sobre a divulgação ou exposição de
      manifestações próprias de sua vida, por isso íntima e privada;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (xi) “Bases legais”: são as hipóteses descritas na Lei Geral de Proteção
      de Dados que autorizam o tratamento de Dados Pessoais e de Dados Pessoais
      Sensíveis, encontradas nos artigos 7º e 11º da referida lei;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (xii) “LGPD”: é a sigla de Lei Geral de Proteção de Dados, legislação que
      tem como principal objetivo proteger os direitos fundamentais de liberdade
      e de privacidade e o livre desenvolvimento da personalidade da pessoa
      natural;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (xiii) “Anonimização”: é o processo que torna um dado impossível de ser
      vinculado a um indivíduo;
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.42cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      (xiv) “Autoridade Nacional de Proteção de Dados” ou “ANPD”: é o órgão da
      administração pública federal responsável por zelar pela proteção de dados
      pessoais e por regulamentar, implementar e fiscalizar o cumprimento da
      LGPD no Brasil.
    </font>
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.28cm" }}
  >
    <br />
    <br />
  </p>
  <p
    align="justify"
    style={{ lineHeight: "150%", marginTop: "0.42cm", marginBottom: "0.28cm" }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>2.</b>
    </font>
    <font size={3} style={{ fontSize: "12pt" }}></font>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>
        PORQUE A OOPPAH COLETA SEUS DADOS PESSOAIS? QUAIS DADOS SÃO COLETADOS?{" "}
      </b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      O tipo e a forma de Dados Pessoais que coletamos depende de como e por que
      você se relaciona conosco.
    </font>
    <font color="#00b050">
      <font size={3} style={{ fontSize: "12pt" }}></font>
    </font>
    <font size={3} style={{ fontSize: "12pt" }}>
      Basicamente são 03 os grupos que possuem acesso à plataforma da OOPPAH
      através de Login: O primeiro grupo diz respeito aos talentos como atores,
      diretores, músicos e artistas em geral que possuem seu próprio perfil
      cujos dados são disponibilizados aos produtores cadastrados na plataforma;
      o segundo grupo diz respeito aos agentes, agências ou empresários que
      realizam a atividade de agenciamento dos talentos do primeiro grupos e
      poderão aceitar a representação de novos talentos que estiverem
      cadastrados na plataforma, e o terceiro grupo refere-se aos contratantes,
      como por exemplo, produtores de elenco, que recebem autorização para
      ingressarem na plataforma.
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Por esse motivo é possível prever as situações de tratamento de dados que
      realizamos, vejamos:
    </font>
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <br />
    <br />
  </p>
  <p
    align="justify"
    style={{
      lineHeight: "150%",
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <br />
    <br />
  </p>
  <div style={{ overflowX: 'auto', width: '100%' }}>
  <table
    style={{ width: '100%', maxWidth: '100%', borderCollapse: 'collapse', boxSizing: 'border-box' }}
    cellPadding={7}
    cellSpacing={0}
  >
    <colgroup>
      <col style={{ width: '20%' }} />
      <col style={{ width: '25%' }} />
      <col style={{ width: '35%' }} />
      <col style={{ width: '20%' }} />
    </colgroup>
    <tbody>
      <tr valign="top">
        <td
          width={104}
          height={17}
          style={{ border: "1px solid #bfbfbf", padding: "0.18cm" }}
        >
          <p align="center" style={{ orphans: 0, widows: 0 }}>
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Origem</b>
            </font>
          </p>
        </td>
        <td
          width={144}
          style={{
            borderTop: "1px solid #bfbfbf",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0.18cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p align="center" style={{ orphans: 0, widows: 0 }}>
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Tipo dos dados</b>
            </font>
          </p>
        </td>
        <td
          width={173}
          style={{
            borderTop: "1px solid #bfbfbf",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0.18cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p align="center" style={{ orphans: 0, widows: 0 }}>
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Finalidade</b>
            </font>
          </p>
        </td>
        <td
          width={112}
          style={{
            borderTop: "1px solid #bfbfbf",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0.18cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p align="center" style={{ orphans: 0, widows: 0 }}>
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Base Legal segundo a LGPD</b>
            </font>
          </p>
        </td>
      </tr>
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr valign="top">
        <td
          width={104}
          height={425}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "1px solid #bfbfbf",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0.18cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Navegação nas Plataformas Digitais
            </font>
          </p>
        </td>
        <td
          width={144}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Dados de navegação</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              : dados coletados por meio de cookies ou device IDs, incluindo IP,
              data e hora de acesso, localização geográfica, tipo de navegador,
              duração da visita e páginas visitadas.
            </font>
          </p>
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Dados sobre o dispositivo de acesso:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              modelo, fabricante, sistema operacional, operadora de telefonia,
              tipo de navegador, tipo e velocidade da conexão.
            </font>
          </p>
        </td>
        <td
          width={173}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Funcionamento do site</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              : ativar funcionalidades essenciais, como software antivírus,
              responsividade do site/aplicativo ao desktop/mobile, entre outras
              funções.
            </font>
          </p>
          <p
            align="justify"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <br />
          </p>
          <p
            align="justify"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Analytics:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              entender seu comportamento de navegação e como o site/aplicativo
              está sendo usado, para melhorar sua experiência como usuário. Os
              dados coletados são agregados e, sempre que possível,
              anonimizados.
            </font>
          </p>
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Marketing:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              direcionamento de conteúdos e publicidade, nossa e de nossos
              parceiros, conforme o seu perfil e preferências.
            </font>
          </p>
        </td>
        <td
          width={112}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Legítimo interesse do Controlador
              <br />
              <br />
              <br />
              <br />
              <br />
            </font>
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <br />
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <br />
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Legítimo interesse do Controlador
               <br />
              <br />
              <br />
              <br />
            </font>
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <br />
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <br />
          </p>
          <p
            align="center"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Legítimo interesse do Controlador
            </font>
          </p>
        </td>
      </tr>
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr valign="top">
        <td
          width={104}
          height={186}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "1px solid #bfbfbf",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0.18cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Formulários de Cadastro (login)
            </font>
          </p>
        </td>
        <td
          width={144}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Dados de cadastro e login:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              {" "}
              e-mail, nome, telefone, endereço e outras informações coletadas
              para preenchimento do perfil (a depender do serviço contratado).
            </font>
          </p>
        </td>
        <td
          width={173}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Prestação dos Serviços:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              realização de vendas e entregas de produtos da store, entre
              outros.
            </font>
          </p>
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Marketing:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              direcionamento de conteúdos e publicidade, nossa e de nossos
              parceiros, conforme o seu perfil e preferências.
            </font>
          </p>
        </td>
        <td
          width={112}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Cumprimento de contrato
               <br />
              <br />
              <br />
              <br />
              <br />
            </font>
          </p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          ></p>
          <p
            align="center"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Legítimo interesse do Controlador
            </font>
          </p>
        </td>
      </tr>
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr valign="top">
        <td
          width={104}
          height={132}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "1px solid #bfbfbf",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0.18cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Canais de suporte
            </font>
          </p>
        </td>
        <td
          width={144}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Dados de cadastro e login:</b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              {" "}
              e-mail, nome, telefone, endereço e outras informações coletadas
              para preenchimento do perfil (a depender do serviço contratado).
            </font>
          </p>
        </td>
        <td
          width={173}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Atendimento às solicitações: </b>
            </font>
            <font size={2} style={{ fontSize: "10pt" }}>
              receber reclamações e solicitações do cliente, prestar
              informações, entre outros.
            </font>
          </p>
        </td>
        <td
          width={112}
          style={{
            borderTop: "none",
            borderBottom: "1px solid #bfbfbf",
            borderLeft: "none",
            borderRight: "1px solid #bfbfbf",
            paddingTop: "0cm",
            paddingBottom: "0.18cm",
            paddingLeft: "0cm",
            paddingRight: "0.18cm"
          }}
        >
          <p
            align="center"
            style={{
              orphans: 0,
              widows: 0,
              marginTop: "0.42cm",
              marginBottom: "0cm"
            }}
          >
            <font size={2} style={{ fontSize: "10pt" }}>
              Cumprimento de contrato
            </font>
          </p>
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: "0.42cm" }}
          ></p>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  <p style={{ marginBottom: "0cm" }}>
    <br />
  </p>
  <p style={{ marginBottom: "0cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>3. COMO A OOPPAH PROTEGE SEUS DADOS PESSOAIS?</b>
    </font>
  </p>
  <p style={{ marginBottom: "0cm" }}>
    <br />
  </p>
  <p align="justify" style={{ textIndent: "1.27cm", marginBottom: "0cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      Compreendemos que a proteção aos dados pessoais faz parte do gerenciamento
      da privacidade, que inclui estratégias, habilidades, pessoas, processos e
      ferramentas necessários para cumprir com exigências apresentadas pela
      legislação.
    </font>
  </p>
  <p align="justify" style={{ textIndent: "1.27cm", marginBottom: "0cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      E, nesse cenário, gerenciamento de segurança e risco, bem como seus
      respectivos responsáveis, encontram, cada vez mais, requisitos complexos e
      restritivos a serem cumpridos para se ter, assim, uma efetiva governança
      de privacidade e manuseio de dados pessoais ao longo de seu ciclo de vida.
      Uma implementação ampla e inclusiva de um Programa de Governança em
      Privacidade é necessária para gerenciar riscos, em ascensão, nas mais
      variadas áreas. Aumentar a confiança de todas as partes interessadas
      necessita que os gestores do gerenciamento de segurança e risco ampliem
      tanto a frequência quanto a amplitude da comunicação, para assim assegurar
      que o uso dos dados pessoais seja granular, com finalidades específicas e
      com riscos mapeados e sob controle.
    </font>
  </p>
  <p align="justify" style={{ textIndent: "1.27cm", marginBottom: "0cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      Por isso, implementamos medidas de segurança, técnicas e administrativas,
      razoáveis e que estão ao nosso alcance para proteger seus dados pessoais
      contra perda, mau uso e acesso não autorizado, divulgação, alteração e
      destruição. Tais medidas incluem, sem se limitar a:
    </font>
  </p>
  <p align="justify" style={{ marginLeft: "1.25cm", marginBottom: "0cm" }}>
    <br />
  </p>
  <ul>
    <li>
      <p align="justify" style={{ marginBottom: "0cm" }}>
        <font size={3} style={{ fontSize: "12pt" }}>
          Estabelecimento de uma política de segurança da informação
          simplificada, que estabeleça controles relacionados ao tratamento de
          dados pessoais, como cópias de segurança, uso de senhas, acesso à
          informação, compartilhamento de dados, atualização de softwares, uso
          de correio eletrônico e uso de antivírus;
        </font>
      </p>
    </li>
    <li>
      <p align="justify" style={{ marginBottom: "0cm" }}>
        <font size={3} style={{ fontSize: "12pt" }}>
          Implementação de um sistema de controle de acesso aplicável a todos os
          usuários, com níveis de permissão na proporção da necessidade de
          trabalhar com o sistema e de acessar dados pessoais;
        </font>
      </p>
    </li>
    <li>
      <p align="justify" style={{ marginBottom: "0cm" }}>
        <font size={3} style={{ fontSize: "12pt" }}>
          Coleta e processamento apenas dos dados pessoais que são realmente
          necessários para atingir os objetivos do tratamento para a finalidade
          pretendida, minimizando a coleta de dados;
        </font>
      </p>
    </li>
    <li>
      <p align="justify" style={{ marginBottom: "0cm" }}>
        <font size={3} style={{ fontSize: "12pt" }}>
          Adoção e atualização periódica de softwares antivírus e antimalwares.
        </font>
      </p>
    </li>
  </ul>
  <p align="justify" style={{ marginBottom: "0cm" }}>
    <br />
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Entretanto, devido à natureza inerente da Internet e outros fatores de
      risco, não podemos garantir que jamais ocorrerá um incidente de segurança
      envolvendo suas informações.{" "}
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Por este motivo, recomendamos que você cuide de sua senha de acesso à
      plataforma, mantenha antivírus e sistemas de firewall atualizados e
      operantes, fique atento a qualquer solicitação de envio de material
      artístico que lhe for solicitado(a) e não envie nenhum arquivo caso o (a)
      solicitante tenha demonstrado atos de má-fé ou despertado algum grau de
      desconfiança quanto à veracidade de suas alegações, e adote as melhores
      precauções para se proteger de ameaças referentes à segurança e à
      privacidade.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>4.COM QUEM A OOPPAH COMPARTILHA OS SEUS DADOS PESSOAIS?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Operamos em parceria com uma série de outras empresas para oferecer nossos
      produtos e serviços. Dessa forma, podemos compartilhar seus Dados Pessoais
      com essas empresas parceiras, sempre buscando preservar ao máximo a sua
      privacidade e, sempre que possível, de forma anonimizada.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      Aqui descrevemos situações em que haverá o compartilhamento de seus Dados
      Pessoais e para quais finalidades:
    </font>
  </p>
  <div style={{ overflowX: 'auto', width: '100%' }}>
  <table
    style={{
      width: '100%',
      maxWidth: '100%',
      borderCollapse: 'collapse',
      boxSizing: 'border-box'
    }}
    cellPadding={7}
    cellSpacing={0}
  >
    <colgroup>
      <col style={{ width: '100%' }} />
    </colgroup>
    <tbody>
      <tr>
        <td
          style={{
            border: '1px solid #bfbfbf',
            padding: '0.18cm',
            verticalAlign: 'top'
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: '0.42cm' }}
          >
            <font size={3} style={{ fontSize: '12pt' }}>
              <b>Fornecedores e prestadores de serviços: </b>
            </font>
            <font size={3} style={{ fontSize: '12pt' }}>
              Compartilhamos dados pessoais com fornecedores e prestadores de
              serviços para permitir que tais partes desempenhem funções em
              nosso nome e sob nossas instruções. As tarefas que estes terceiros
              fornecem incluem, mas não estão limitadas a gerenciamento de
              relacionamento com o cliente, infraestrutura, captação de
              clientes, hospedagem do Site, atendimento ao cliente, tecnologia
              da informação, análise de negócios, campanhas de marketing e
              provimento de conferências e eventos. Nossos prestadores de
              serviços não coletam, vendem ou utilizam seus dados pessoais
              fornecidos por nós, exceto quando necessário para executar os
              serviços especificados no contrato, ou conforme solicitado por
              lei.
            </font>
          </p>
        </td>
      </tr>

      <tr>
        <td
          style={{
            borderTop: 'none',
            borderBottom: '1px solid #bfbfbf',
            borderLeft: '1px solid #bfbfbf',
            borderRight: '1px solid #bfbfbf',
            paddingTop: '0cm',
            paddingBottom: '0.18cm',
            paddingLeft: '0.18cm',
            paddingRight: '0.18cm',
            verticalAlign: 'top'
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: '0.42cm' }}
          >
            <font size={3} style={{ fontSize: '12pt' }}>
              <b>Fornecedores terceirizados: </b>
            </font>
            <font size={3} style={{ fontSize: '12pt' }}>
              nos relacionamos com fornecedores terceirizados, para analisar
              como os usuários utilizam os nossos Produtos. Tais fornecedores
              poderão utilizar dados coletados para rastrear e examinar o uso
              dos nossos produtos; criar estatísticas e relatórios para diversos
              fins comerciais, e para compartilhá-los com anunciantes,
              prestadores de serviços ou parceiros comerciais da empresa, a fim
              de oferecer-lhe produtos potencialmente desejáveis.
            </font>
          </p>
        </td>
      </tr>

      <tr>
        <td
          style={{
            borderTop: 'none',
            borderBottom: '1px solid #bfbfbf',
            borderLeft: '1px solid #bfbfbf',
            borderRight: '1px solid #bfbfbf',
            paddingTop: '0cm',
            paddingBottom: '0.18cm',
            paddingLeft: '0.18cm',
            paddingRight: '0.18cm',
            verticalAlign: 'top'
          }}
        >
          <p
            align="justify"
            style={{ orphans: 0, widows: 0, marginTop: '0.42cm' }}
          >
            <font size={3} style={{ fontSize: '12pt' }}>
              <b>Autoridades Públicas:</b>
            </font>
            <font size={3} style={{ fontSize: '12pt' }}>
              Podemos compartilhar dados pessoais a pedido das autoridades
              policiais ou agências governamentais bem como em resposta a
              intimações, ordens judiciais ou outro processo legal a fim de
              estabelecer, proteger ou exercer nossos direitos legais ou outros,
              ou para nos defender contra uma reivindicação legal ou tal como
              exigido ou permitido por lei, ou para proteger os direitos,
              propriedade ou segurança de um cliente ou qualquer outra pessoa.
              Também podemos revelar dados pessoais para investigar ou impedir
              que você viole qualquer relação contratual ou de outro tipo que
              mantenha conosco, ou sua atividade ilegal ou prejudicial.
            </font>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>5. A OOPPAH TRANSFERE DADOS PESSOAIS PARA OUTROS PAÍSES?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Sim. Embora nossa sede esteja situada no Brasil, devido à natureza do
      nosso negócio, compartilhamos dados pessoais internacionalmente. Essa
      transferência ocorre por conta de certos fornecedores e parceiros
      comerciais, que podem estar localizados nesses locais.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>6.QUAIS SÃO OS SEUS DIREITOS COMO TITULAR DE DADOS PESSOAIS?</b>
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      A LGPD a você uma série de direitos durante o tratamento de seus Dados
      Pessoais e nós estamos comprometidos a cumpri-los. São eles:
    </font>
  </p>
  <div style={{ overflowX: 'auto', width: '100%' }}>
  <table
    style={{
      width: '100%',
      maxWidth: '100%',
      borderCollapse: 'collapse',
      boxSizing: 'border-box'
    }}
    cellPadding={7}
    cellSpacing={0}
  >
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <tbody>
      {/* Cabeçalho */}
      <tr valign="top">
        <td style={{ border: '1px solid #bfbfbf', padding: '0.18cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}><b>Direito</b></font>
        </td>
        <td style={{ border: '1px solid #bfbfbf', padding: '0.18cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}><b>Significado</b></font>
        </td>
        <td style={{ border: '1px solid #bfbfbf', padding: '0.18cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}><b>Como exercê-lo</b></font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* Linha: Confirmação da existência de tratamento */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Confirmação da existência de tratamento</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular dos dados tem o direito de confirmar se nós realizamos o tratamento de seus dados pessoais.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a confirmação através de requerimento à OOPPAH, e nossa resposta será feita através de declaração que indique a origem dos dados, os critérios usados e a finalidade do tratamento.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* Linha: Acesso aos seus dados Pessoais */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Acesso aos seus dados Pessoais que estão sendo tratados</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular dos dados tem o direito de obter uma cópia dos dados pessoais que nós possuímos em nossos arquivos.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar o acesso a seus dados através de requerimento à OOPPAH, e nossa resposta será feita através de declaração que indique quais dados pessoais estão sendo tratados.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Anonimização, bloqueio ou eliminação de dados */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Anonimização, bloqueio ou eliminação de dados</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular de dados também tem o direito de solicitar a anonimização, bloqueio ou eliminação de dados quando eles forem desnecessários, excessivos ou tratados em desconformidade com a lei.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a anonimização, o bloqueio ou a eliminação de dados através de requerimento à OOPPAH, e nossa resposta será feita através de declaração que indique a anonimização, o bloqueio e a eliminação de seus dados pessoais.
          </font>
        </td>
      </tr>

          <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Correção de seus dados Pessoais */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Correção de seus dados Pessoais</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular dos dados tem o direito de nos solicitar a correção de dados pessoais incompletos, inexatos ou desatualizados.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a correção através de requerimento à OOPPAH, e nossa resposta será feita através de declaração que indique a correção de seus dados pessoais.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Portabilidade de seus dados Pessoais */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Portabilidade de seus dados Pessoais</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular dos dados tem o direito de solicitar a transferência das suas informações pessoais a outro fornecedor de serviço ou produto.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a portabilidade através de requerimento à OOPPAH, e nossa resposta será feita através de declaração que confirme a portabilidade de seus dados pessoais.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Eliminação dos dados tratados com consentimento */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Eliminação dos dados tratados com consentimento</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Se você consentiu com o tratamento, mas mudou de ideia e não quer mais que tratemos seus dados pessoais, ele pode solicitar a eliminação desses dados.
            No entanto, há situações em que esse direito não pode ser exercido, como quando precisarmos conservar os dados para cumprir uma obrigação legal ou regulatória.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a eliminação através de requerimento à OOPPAH, e nossa resposta será feita através de declaração confirmando a eliminação de dados tratados com seu consentimento.
          </font>
        </td>
      </tr>

            <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Informações sobre o compartilhamento de dados pessoais com entidades Públicas */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Informações sobre o compartilhamento de dados pessoais com entidades Públicas</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Receber informações relacionadas ao compartilhamento de seus dados pessoais.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar as informações sobre o compartilhamento através de nossos canais de atendimento disponibilizados nesta Política de Privacidade, e nós nos reservamos ao direito de não compartilhar essa informação caso os Dados Pessoais tenham sido compartilhados com alguma autoridade pública em segredo de justiça.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Revogação do consentimento dado anteriormente */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Revogação do consentimento dado anteriormente</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Retirar seu consentimento para nossa coleta ou uso de seus dados pessoais, sempre que o consentimento tiver sido a base legal que justificou o tratamento.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular deverá solicitar a revogação através de nossos canais de atendimento disponibilizados nesta Política de Privacidade.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Oposição ao tratamento realizado com dispensa de consentimento */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Oposição ao tratamento realizado com dispensa de consentimento, desde que não haja obrigação legal no tratamento e seja possível tal manifestação</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Discordar do tratamento dos seus dados pessoais. Você pode fazer isso quando tratamos seus dados pessoais segundo a base legal de interesse legítimo ou quando tratamos seus dados pessoais para publicidade personalizada.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            O titular poderá manifestar oposição ao tratamento de seus dados através de requerimento à OOPPAH, e nossa resposta será feita através de declaração, e obstará a continuidade do tratamento de seus dados se assim for possível.
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* LINHA: Direito de apresentar uma reclamação */}
      <tr valign="top">
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Direito de apresentar uma reclamação</b>
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Entre em contato com a Autoridade Nacional de Proteção de Dados (ANPD) sobre quaisquer dúvidas ou preocupações.
          </font>
        </td>
        <td style={{
          border: '1px solid #bfbfbf', padding: '0.18cm',
          textAlign: 'justify', verticalAlign: 'top'
        }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            A Autoridade (ANPD) disponibiliza um formulário específico em seu site.
          </font>
        </td>
      </tr>
    </tbody>
  </table>
</div>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      É importante ressaltar que:
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    ●
    <font size={3} style={{ fontSize: "12pt" }}>
      Nenhum direito é absoluto e há situações em que é possível que não
      consigamos atender aos seus requerimentos, casos em que indicaremos os
      motivos como, por exemplo, o cumprimento de obrigações legais ou
      regulatórias.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    ●
    <font size={3} style={{ fontSize: "12pt" }}>
      Sempre que o Titular exercer seus direitos, nós poderemos solicitar
      algumas informações complementares para fins de comprovação da sua
      identidade, buscando impedir fraudes. Fazemos isso para garantir sua
      segurança e privacidade. Ainda, algumas solicitações podem não ser
      respondidas de forma imediata, mas nos comprometemos a responder todas as
      requisições em um prazo razoável e sempre em conformidade com a legislação
      aplicável.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <br />
    <br />
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>7. POR QUANTO TEMPO OS DADOS PESSOAIS SERÃO ARMAZENADOS?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Possuímos uma política de retenção de Dados Pessoais alinhada com a LGPD,
      por isso, seus Dados Pessoais só serão armazenados pelo tempo necessário
      para o cumprimento das finalidades para as quais foram coletados, salvo se
      houver qualquer outra razão para sua manutenção como, por exemplo, o
      cumprimento de quaisquer obrigações legais, regulatórias, contratuais,
      entre outras, desde que fundamentadas com uma Base Legal.
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Isto porque, existem leis que determinam prazos específicos para o
      armazenamento de determinadas categorias de Dados Pessoais, e dessa forma
      caberá a OOPPAH observá-las.
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <br />
    <br />
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>8.COMO REALIZAMOS O TRATAMENTO DE DADOS PESSOAIS DE CRIANÇAS?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Segundo o Estatuto da Criança e do Adolescente estabelece é considerada
      criança a pessoa com até doze anos de idade incompletos, e adolescente a
      que possuir entre doze e dezoito anos incompletos de idade.{" "}
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Segundo a LGPD o tratamento dos dados pessoais de crianças deverá ser
      realizado com o consentimento específico e em destaque dado por pelo menos
      um dos pais ou responsável legal. Esse consentimento é coletado por nós a
      partir de um documento específico, produzido e armazenado de acordo com a
      lei.{" "}
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Além disso, ao realizar o tratamento dos dados pessoais de crianças, a
      OOPPAH torna pública a informação sobre os tipos de dados coletados, a
      forma de sua utilização e os procedimentos para o exercício dos direitos
      trazidos pelo artigo 18 da LGPD e por isso informamos que:
    </font>
  </p>
  <div style={{ overflowX: 'auto', width: '100%' }}>
  <table
    style={{
      width: '100%',
      maxWidth: '100%',
      borderCollapse: 'collapse',
      boxSizing: 'border-box'
    }}
    cellPadding={7}
    cellSpacing={0}
  >
    <colgroup>
      <col style={{ width: '25%' }} />
      <col style={{ width: '25%' }} />
      <col style={{ width: '25%' }} />
      <col style={{ width: '25%' }} />
    </colgroup>
    <tbody>
      {/* Cabeçalho */}
      <tr valign="top">
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Dados de Crianças coletados pela OOPPAH</b>
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Finalidade da Coleta</b>
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Forma de exercício de direitos</b>
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            <b>Solicitação de Consentimento</b>
          </font>
        </td>
      </tr>

      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />
      <tr />

      {/* Conteúdo */}
      <tr valign="top">
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Dados de Cadastro tais como: Foto, Número do RG, Número de CPF, Nome dos Pais, Endereço, Habilidades, Características Físicas, Grau de escolaridade, entre outros...
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Realização de Cadastro na Plataforma OOPPAH
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Declaração dada pela OOPPAH a partir de requerimento solicitado pelo Titular
          </font>
        </td>
        <td style={{ border: '1px solid #000000', padding: '0cm 0.19cm', textAlign: 'center' }}>
          <font size={2} style={{ fontSize: '10pt' }}>
            Sim
          </font>
        </td>
      </tr>
    </tbody>
  </table>
</div>

  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  ></p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>9.QUAIS SÃO NOSSAS RESPONSABILIDADES?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Via de regra, atuamos como controladores de dados pessoais como por
      exemplo, quando cedemos informações às plataformas; selecionamos
      potenciais funcionários; realizamos atividades de marketing; respondemos a
      solicitações da mídia e através de orientação de consultas e suporte ao
      cliente.
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Nossa responsabilidade é cuidar dos seus dados pessoais, e utilizá-los
      somente para as finalidades descritas neste aviso. E para garantir a sua
      privacidade e a proteção dos seus Dados Pessoais, adotamos as práticas de
      segurança adequadas para nosso mercado, com o uso de sistemas de segurança
      da informação em observância a legislação vigente.{" "}
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <br />
    <br />
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>10. COMO FALAR SOBRE DADOS PESSOAIS COM A OOPPAH?</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Para realizar qualquer solicitação ou tirar dúvidas a respeito de seus
      dados pessoais, você poderá falar conosco através do Contato@ooppah.com.br
    </font>
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <br />
    <br />
  </p>
  <p align="justify" style={{ marginTop: "0.42cm", marginBottom: "0.42cm" }}>
    <font size={3} style={{ fontSize: "12pt" }}>
      <b>11.MUDANÇAS NO AVISO DE PRIVACIDADE</b>
    </font>
  </p>
  <p
    align="justify"
    style={{
      textIndent: "1.27cm",
      marginTop: "0.42cm",
      marginBottom: "0.42cm"
    }}
  >
    <font size={3} style={{ fontSize: "12pt" }}>
      Publicaremos qualquer atualização deste Aviso de Privacidade alterando a
      data de “Atualização” na parte superior desta página. Todas as
      atualizações deste Aviso de Privacidade entrarão em vigor imediatamente
      após a publicação.
    </font>
  </p>
</>

        </TermsText>
    </MainContainer>
  );
}
